import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Slider = () => {
  const { t } = useTranslation();
  return (
    <div
      className="container header-content d-flex"
      style={{ marginTop: "30vh" }}
    >
      <div className="row w-100">
        <div className="col-sm-12 col-lg-6 col-md-10">
          <h1>{t("welcome")}</h1>
          <p>
            {t("welcome_portal")} <br />
            {t("resident_info")}
          </p>
          <div>
            <Link
              to="/getstarted"
              type="button"
              className="btn btn-success p-lg-3 btn-margin shadow"
            >
              {t("access_enrolment_service")}
            </Link>
            {/* <Link
              to="/help"
              type="button"
              className="btn btn-outline-secondary p-lg-3"
            >
              Learn More
            </Link> */}
          </div>
        </div>
        <div className="col-7"></div>
      </div>
    </div>
  );
};

export default Slider;
